
import InfiniteScroll from "infinite-scroll";

(function($) {

    var $browse_dataset,
        $browse_filter,
        $browse_metadata,
        $browse_paging,
        $browse_paging_next;

    var filterRequest = null;

    var infScroll;

    $(document).ready(function() {

        // Exist if not found
        if (!initSelectors()) return;

        initScroll();

        initFilter(function () {
            initScroll();
        });
    })


    function initSelectors() {
        $browse_dataset = $('.dataset-browse');
        $browse_filter = $('.dataset-filter');
        $browse_metadata = $('.dataset-metadata');
        $browse_paging = $('.dataset-paging');
        $browse_paging_next = $('.pagination-next-button');

        return $browse_dataset.length
    }

    /**
     * Toggle Loading State
     * - Disables form inputs
     * @param bool
     */
    function loadingState(bool) {
        $browse_dataset.parent().toggleClass('loading', bool);

        $browse_dataset.find('.btn').toggleClass('btn-disabled', bool);

        $browse_dataset.find('.form-control').toggleClass('disabled', bool).attr('disabled', bool);

        //$browse_dataset.find('.dropdown.open').removeClass('open');
    }

    function handleCountryLink(country_id) {
        var $item_country_all = $('.link-browse-country-all');
        var $item_country = $('.link-browse-country');
        var $link_country = $item_country.children('a');

        // Menu must contain both links for this to work
        if ($item_country_all.length && $item_country) {
            if (country_id) {
                // Show country link
                $item_country_all.addClass('d-none');
                $item_country.removeClass('d-none');

                // Save orig href before modify should be: /stockists/country/
                if (!$link_country.data('href')) {
                    $link_country.data('href', $link_country.attr('href'))
                }

                $link_country.attr('href', $link_country.data('href') + '/' + country_id)
            } else {
                // Reset to all countries link
                $item_country_all.removeClass('d-none');
                $item_country.addClass('d-none');
            }
        }
    }

    function initFilter(callback) {
        $browse_filter.find('[data-filter-change]').change(function() {
            var minDelay = $.Deferred();
            var minSecondDelay = 1000;

            setTimeout(function () {
                minDelay.resolve();
            }, minSecondDelay);

            loadingState(true);

            filterRequest = $.ajax({
                type: 'GET',
                url: location.protocol + '//' + location.host + location.pathname,
                data: $('#form-filter').serialize(),
                beforeSend: function () {
                    if (filterRequest !== null) {
                        filterRequest.abort();
                    }
                }
            });

            // Update replace all countries link with individual country link
            if (this.name == 'country') {
                handleCountryLink(this.value);
            }

            $.when(filterRequest, minDelay).then(function (data) {
                loadingState(false);

                var $response = $(data[0]);

                if ($response.find('.dataset-browse').length) {
                    // Replace
                    $browse_dataset.html($response.find('.dataset-browse').html());

                    // Paging
                    $browse_paging.html($response.find('.dataset-paging').html());

                    var $response_paging_next = $response.find('.pagination-next-button');
                    if ($response_paging_next.length) {
                        $browse_paging_next.html($response_paging_next.html());
                    } else {
                        $browse_paging_next.remove();
                    }

                    // update inifiniate scroll new html

                    // update filter
                    $browse_filter.find('.dataset-filter-type').html($response.find('.dataset-filter-type').html());
                    $browse_filter.find('.dataset-filter-country').html($response.find('.dataset-filter-country').html());

                    var $response_metadata = $response.find('.dataset-metadata');
                    var metadata_html = '';
                    if ($response_metadata.length) {
                        metadata_html = $response_metadata.html();
                    }

                    $browse_metadata.html(metadata_html);

                    // update selectors after updates for filter change event
                    initSelectors();

                    // Fix bootstrap
                    //$browse_filter.find('[data-toggle="buttons"]').button();

                    $browse_filter.find('[name=reset]').removeClass('d-none')

                    // Update lazy img
                    $browse_dataset.find('img.lazy').each(function () {
                        $(this).attr('src', $(this).data('src')).removeClass('lazy');
                    })

                    initFilter(function () {
                        initScroll();
                    });
                }

                if (typeof callback === 'function') {
                    callback();
                }
            })
        })

        // Onload
        $browse_filter.find('[name=country]').each(function () {
            if (this.value) {
                handleCountryLink(this.value)
            }
        })
    }

    /**
     * Init InfiniteScroll
     * @param $browse_dataset
     */
    function initScroll() {
        if (infScroll) {
            infScroll.destroy();
            $browse_dataset.data('infinitescroll', null);
        }

        // prevent error if no next page
        if ($browse_paging.find('.paging-next').length == 0) {
            $browse_paging_next.hide();
            return;
        } else {
            $browse_paging_next.show();
        }

        infScroll = new InfiniteScroll($browse_dataset[0], {
            path: '.paging-next > a',
            append: '.dataset-browse > div',

            checkLastPage: true,
            // Checks if page has path selector element
            // Set to string if path is not set as selector string:
            //   checkLastPage: '.pagination__next'

            prefill: false,
            // Loads and appends pages on intialization until scroll requirement is met.

            responseType: 'document',
            // Sets the type of response returned by the page request.
            // Set to 'text' to return flat text for loading JSON.

            scrollThreshold: 400,
            // Sets the distance between the viewport to scroll area
            // for scrollThreshold event to be triggered.

            elementScroll: false,
            // Sets scroller to an element for overflow element scrolling

            loadOnScroll: false,
            // Loads next page when scroll crosses over scrollThreshold

            history: false,
            // Changes the browser history and URL.
            // Set to 'push' to use history.pushState()
            //    to create new history entries for each page change.

            historyTitle: false,
            // Updates the window title. Requires history enabled.

            hideNav: false,
            //hideNav: '.widget-pagination',
            // Hides navigation element

            status: '.pagination-status',
            // Displays status elements indicating state of page loading:
            // .infinite-scroll-request, .infinite-scroll-load, .infinite-scroll-error
            // status: '.page-load-status'

            button: '.pagination-next-button',
            // Enables a button to load pages on click
            // button: '.load-next-button'

        })

        // get Infinite Scroll instance
        infScroll.on('append', function (response, path, items) {
            var $response = $(response);

            // Animate new items
            $(items).css({
                opacity: 0
            }).animate({
                opacity: 1
            });

            var pagination_html = $response.find('.dataset-paging').html();
            $browse_paging.html(pagination_html);

            var remaining_total_val = $response.find('.paging_remaining_total').val();
            $('.paging_remaining_total').val(remaining_total_val);

            $browse_paging_next.find('[data-browse="remaining-total"]').text(remaining_total_val);

            // Update lazy img
            $(items).find('img.lazy').each(function () {
                $(this).attr('src', $(this).data('src')).removeClass('lazy');
            })
        });
    } // infiniate scroll

})(jQuery);
